import { createApp } from 'vue';

/**
 *  样式需在 app 创建前导入，避免不生效
 */
// 全局样式
import '@/assets/styles/globals.scss';

// Animate.css 用于其他自定义动画
import 'animate.css/animate.css';
// AOS滚动过渡
import 'aos/dist/aos.css';
import { useAOS } from '@/hooks/core/useAOS';
useAOS();

// Element-Plus
// 样式全局引入所有的（我们强烈建议直接引入全部的样式文件，虽然这看起来会增大整个应用的体积，但这样做可以避免引入额外的打包工具插件（减少负担））
// 导入 element-plus 自带的过渡效果
import 'element-plus/theme-chalk/base.css';
// 加载 svg 图标
import 'virtual:svg-icons-register';

import App from './App.vue';
const app = createApp(App);

// Vuex
import store from '@/store';
app.use(store);

// Router
import router from '@/router';
app.use(router);

// 挂载全局属性
import globalProperties from '@/utils/global.properties';
globalProperties(app);

// 自定义指令
import directives from '@/directives';
directives(app);

app.mount('#app');
